//bao migrate skip
import template from "./date-time-picker.html";
import * as DateTimePicker from "./date-time-picker-module";
import * as ko from "knockout";
export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var e = componentInfo.element;
            var vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    vm.dispose();
                }
            });
            vm = new DateTimePicker.DateTimePickerComponent(params, componentInfo.element);
            return vm;
        }
    },
    template: template
};